export const emailRegEx: RegExp =
  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const mobileNumberRegEx: RegExp = /^[0-9]{10}$/;
export const altMobileNumberRegEx: RegExp = /^(\d{10})?$/;
export const pinRegEx: RegExp = /^[0-9]{6}$/;
export const panRegex: RegExp = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
export const gstRegex: RegExp =
  /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[0-9A-Z]{1}$/;
export const nameRegex: RegExp = /^[a-zA-Z][a-zA-Z\s]*$/;
export const aadhaarRegEx: RegExp = /^[2-9][0-9]{11}$/;
